
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/amazon-eventbridge",
      function () {
        return require("private-next-pages/destinations/amazon-eventbridge.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/amazon-eventbridge"])
      });
    }
  